/* V2: delegated navigation survives Dawn variant section updates. */
(() => {
  if (window.avTableauSizeGuideReady) return;
  window.avTableauSizeGuideReady = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-av-size-guide-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const details = document.getElementById(link.getAttribute('href').slice(1));
    if (!details || details.tagName !== 'DETAILS') return;
    event.preventDefault();
    details.open = true;
    details.querySelector('summary')?.focus({preventScroll: true});
    details.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
  });
})();
